import { useCallback, useEffect, useRef } from 'react';
const autofillAnimationName = 'reactCartAutofillStart';
const autofillStyleId = 'react-cart-autofill-style';
const installAutofillStyle = () => {
    if (document.getElementById(autofillStyleId))
        return;
    const style = document.createElement('style');
    style.id = autofillStyleId;
    style.textContent = `
        @keyframes ${autofillAnimationName} {
            from { opacity: 0.99; }
            to { opacity: 1; }
        }

        .react-cart-autofill-scope input:-webkit-autofill {
            animation-name: ${autofillAnimationName};
            animation-duration: 0.01s;
        }
    `;
    document.head.appendChild(style);
};
export const parseAutofillDate = (value) => {
    const match = value === null || value === void 0 ? void 0 : value.trim().match(/^(\d{1,4})[.\-/](\d{1,2})[.\-/](\d{1,4})$/);
    if (!match)
        return undefined;
    const yearFirst = match[1].length == 4;
    const year = Number.parseInt(yearFirst ? match[1] : match[3]);
    const month = Number.parseInt(match[2]);
    const day = Number.parseInt(yearFirst ? match[3] : match[1]);
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() != year || date.getMonth() != month - 1 || date.getDate() != day)
        return undefined;
    return date;
};
export function useAutofillSync(syncFromDom) {
    const rootRef = useRef(null);
    const syncRef = useRef(syncFromDom);
    const timersRef = useRef([]);
    syncRef.current = syncFromDom;
    const runSync = useCallback(() => {
        if (rootRef.current)
            syncRef.current(rootRef.current);
    }, []);
    const scheduleSync = useCallback(() => {
        runSync();
        timersRef.current.forEach(timer => window.clearTimeout(timer));
        timersRef.current = [50, 250, 750].map(delay => window.setTimeout(runSync, delay));
    }, [runSync]);
    useEffect(() => {
        installAutofillStyle();
        const onWindowFocus = () => scheduleSync();
        const onPageShow = () => scheduleSync();
        const onVisibilityChange = () => {
            if (!document.hidden)
                scheduleSync();
        };
        window.addEventListener('focus', onWindowFocus);
        window.addEventListener('pageshow', onPageShow);
        document.addEventListener('visibilitychange', onVisibilityChange);
        scheduleSync();
        return () => {
            timersRef.current.forEach(timer => window.clearTimeout(timer));
            window.removeEventListener('focus', onWindowFocus);
            window.removeEventListener('pageshow', onPageShow);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, [scheduleSync]);
    const onInputCapture = useCallback((event) => {
        const nativeEvent = event.nativeEvent;
        if (!nativeEvent.inputType || nativeEvent.inputType == 'insertReplacementText')
            scheduleSync();
    }, [scheduleSync]);
    const onAnimationStartCapture = useCallback((event) => {
        if (event.animationName == autofillAnimationName)
            scheduleSync();
    }, [scheduleSync]);
    return {
        rootRef,
        autofillProps: {
            onAnimationStartCapture,
            onInputCapture,
            onBlurCapture: scheduleSync,
        },
    };
}
